import { useUrlFilters } from "@/hooks/use-url-filters";
import { useSearchPageMapData } from "@/providers/search";
import { MapItemWithCoodId } from "@/types/search";
import { useMemo } from "react";

/**
 * Custom hook to determine SEO banner visibility and calculate total properties count
 * Shared logic between desktop and mobile search layouts
 */
export function useSEOBannerVisibility() {
	const { filters } = useUrlFilters();
	const mapData = useSearchPageMapData(state => state.mapData);

	// Calculate total count of listings
	const totalPropertiesCount = useMemo(() => {
		if (!mapData || mapData.length === 0) return 0;
		return mapData.reduce((total: number, mapItem: MapItemWithCoodId) => {
			return total + (mapItem.sups?.length || 0);
		}, 0);
	}, [mapData]);

	// Check if we should show SEO banner (generic searches without specific property type filter)
	const shouldShowSeoBanner = useMemo(() => {
		const propertyType = filters.propertyType;
		// Show banner for general searches (no property type) or generic apartment/villa/house searches
		return !propertyType || propertyType === "apartment" || propertyType === "villa" || propertyType === "house";
	}, [filters.propertyType]);

	return {
		shouldShowSeoBanner,
		totalPropertiesCount,
	};
}
